export const TIPTAP_FORMSG_NODE_PRIORITY = 300

export const TIPTAP_CARDS_DESCRIPTION_CHAR_LIMIT = 300
export const TIPTAP_CARDS_MAXIMUM = 18
